import DOMPurify from 'dompurify';
import { ChevronDown, ChevronUp, ClipboardCheck } from 'lucide-react';

const Item = ({ item, open, onToggle }) => (
  <div className={`rounded-xl border ${open ? 'border-blue-200 bg-white' : 'border-gray-200 bg-gray-50/50'}`}>
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={open}
      className="flex w-full items-center gap-3 px-4 py-3 text-left"
    >
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white">
        <ClipboardCheck size={18} className="text-teamcare-blue" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold text-secondary-900">{item.title}</p>
        {item.description && <p className="text-xs text-secondary-400">{item.description}</p>}
      </div>
      <span className="flex shrink-0 items-center gap-1 text-sm font-semibold text-teamcare-blue">
        {open ? 'Hide' : 'View'}
        {open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </span>
    </button>

    {open && (
      <div className="border-t border-gray-100 px-4 py-4 sm:px-6">
        <div
          className="text-sm leading-relaxed text-secondary-700 [&_h1]:mb-1 [&_h1]:mt-4 [&_h1]:text-[15px] [&_h1]:font-bold [&_h1]:text-secondary-900 [&_h1:first-child]:mt-0 [&_ul]:list-disc [&_ol]:list-decimal [&_ul]:pl-5 [&_ol]:pl-5 [&_li]:my-1 [&_a]:text-teamcare-blue [&_a]:underline [&_blockquote]:border-l-2 [&_blockquote]:border-gray-200 [&_blockquote]:pl-3"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.html) }}
        />

        <button
          type="button"
          onClick={onToggle}
          className="ml-auto mt-4 flex items-center gap-1 text-sm font-semibold text-teamcare-blue"
        >
          Hide instructions
          <ChevronUp size={16} />
        </button>
      </div>
    )}
  </div>
);

export default Item;
